import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import Reveal from '@/components/common/Reveal';
import { buttonVariants } from '@/components/ui/button';
import { CONTACT_INFO } from '@/constants/contact';

export const FinalCTA = () => (
  <section className="py-24 md:py-36 bg-secondary/50 border-y border-border">
    <div className="mx-auto container-editorial">
      <Reveal>
        <div className="label-eyebrow mb-6">Chapter — Start Here</div>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="font-serif text-5xl sm:text-6xl md:text-8xl lg:text-[10rem] leading-[0.9] tracking-tight text-balance">
          Share your <span className="italic-serif text-sienna">idea</span> we'll
          <span className="italic-serif text-sienna"> handle</span> the rest.
        </h2>

      </Reveal>
      <Reveal delay={0.2}>
        <div className="mt-10 md:mt-14 flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-6">
          <Link to="/contact" className={buttonVariants({ variant: 'editorial' })}>
            Send us your brief <ArrowUpRight className="w-4 h-4" />
          </Link>
          <a href={`mailto:${CONTACT_INFO.email}`} className={buttonVariants({ variant: 'ghost-editorial' })}>
            {CONTACT_INFO.email}
          </a>
          <span className="font-mono text-xs uppercase tracking-widest text-muted-foreground md:ml-2">
            Replies same day · Mon–Fri
          </span>
        </div>
      </Reveal>
    </div>
  </section>
);

export default FinalCTA;
